import {ModalBody} from "@/components/modal/index";
import styled from "styled-components";
import {ButtonWrap, RequiredStar, TitleContentInner, TitleContentWrap} from "@/styles/CommonStyle";
import Input from "@/components/common/Input";
import {useRef, useState} from "react";
import Button from "@/components/common/Button";
import {isEmail, setToast} from "@/utils";
import {SIZES} from "@/components/constants";

const NewsSubscribeModal = ({handleCloseModal, modalDepth, confirmFunc}) => {
    const [mailInput, setMailInput] = useState("");
    const submittingRef = useRef(false);
    return(
        <ModalBody className={"news-body"}>
            <NewsSubscribeWrap>
                <div className={"news-desc-area"}>구독받으실 이메일 주소를 입력해주세요.</div>
                <div className={"news-input-area"}>
                    <Input
                        inputType="text"
                        placeholder="이메일 형식으로 입력"
                        width={"fill"}
                        value={mailInput}
                        onChange={(e) => {
                            setMailInput(e.target.value)
                        }}
                    />
                </div>
                <ButtonWrap className={"center subscribe-btn-wrap"} $gap={10}>
                    <Button
                        type="solid"
                        size="m"
                        round={true}
                        text={"취소"}
                        onClickFunc={async () => {
                            handleCloseModal(modalDepth);
                        }}
                    />
                    <Button
                        type="fill"
                        size="m"
                        round={true}
                        text={`구독하기`}
                        onClickFunc={async () => {

                            if(!mailInput){
                                alert("메일을 작성 해주세요.");
                                return;
                            }
                            if(!isEmail(mailInput)){
                                alert("메일형식이 맞지 않습니다.");
                                return;
                            }
                            if (submittingRef.current) return;
                            submittingRef.current = true;
                            try {
                                const res = await fetch(`${process.env.NEXT_PUBLIC_API_BASE_URL}/api/subscribe`, {
                                    method: "POST",
                                    headers: { "Content-Type": "application/json" },
                                    body: JSON.stringify({ email: mailInput }),
                                });
                                if(res.ok){
                                    setMailInput("");
                                    confirmFunc();
                                }

                            } catch (e) {

                            }
                        }}
                    />
                </ButtonWrap>
            </NewsSubscribeWrap>
        </ModalBody>
    )
}
const NewsSubscribeWrap = styled.div`
    .subscribe-btn-wrap{
        margin-top: 40px;
        button{
            width: 100%;
            height: 44px;
        }
    }
    .news-desc-area{
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        text-align: center;
        margin-bottom: 20px;
    }
    .news-input-area{
        input::placeholder {
            text-align: center;
        }
    }
    @media (max-width: ${SIZES.TABLET}) {
        .news-desc-area{
            margin-bottom: 10px;
        }
    }
`
export default NewsSubscribeModal